import { CircularProgress, LinearProgress, Stack, Typography, type SxProps } from '@mui/material';

interface Props {
    message?: string;
    isCircular?: boolean;
    sx?: SxProps;
    rootSx?: SxProps;
}

const Loader = ({ message, isCircular = false, sx, rootSx }: Props) => {
    return (
        <Stack
            direction="column"
            sx={{ py: 4, justifyContent: 'center', alignItems: 'center', ...rootSx }}
        >
            <Stack
                direction="column"
                sx={{ justifyContent: 'center', alignItems: 'center', gap: 2, ...sx }}
            >
                {isCircular ? <CircularProgress /> : <LinearProgress sx={{ mb: 2, width: 200 }} />}
                {message && (
                    <Typography variant="body2" color="text.secondary">
                        {message}
                    </Typography>
                )}
            </Stack>
        </Stack>
    );
};

export default Loader;
